
<div
  :id="content.idHTML"
  class="w-100 carte-promo"
  :class="[jel_getClassObject(content), isPromoActive ? 'd-flex' : 'd-none']"
  :style="{
    '--couleurDegrade': content.couleur,
  }"
>
  <Carte :content="contentCarte">
    <div
      class="cursor-pointer carte d-flex h-100"
      :class="
        jel_isCarteLarge(content)
          ? { 'flex-row-reverse': content.positionnementTexteDesktop !== 'droite' }
          : 'flex-column'
      "
      @click="jel_forcerClickHyperlien(refRedirection)"
    >
      <b-link
        :ref="refRedirection"
        v-bind="jel_getLienBinding(content.lien)"
        class="d-none"
        @click.capture="gaPreventClick"
      >
        <!-- conserver pour accessibilité -->
        invisible
      </b-link>
      <div
        class="p-0 overflow-hidden flex-grow-1"
        :class="{ 'col-xl-6': jel_isCarteLarge(content) }"
      >
        <MediaImageX3
          :show="true"
          :content="contentMediaImageX3"
          :class="{ degrade: content.afficherDegrade == 'true' }"
        ></MediaImageX3>
      </div>
      <div class="p-0" :class="jel_isCarteLarge(content) ? 'd-lg-flex col-lg-6 ' : 'h-40'">
        <CarteInfoPrimairePromo
          :content="content"
          :class="
            jel_isCarteLarge(content)
              ? 'd-lg-flex align-items-lg-center w-lg-100'
              : 'h-100 info-primaire-promo-5x7'
          "
        ></CarteInfoPrimairePromo>
      </div>
    </div>
  </Carte>
</div>
